angular.module('myappointments').controller('ScheduleAppointmentCtrl',
    ['$scope', '$q', '$log', 'ListService', 'MyAppointmentsRepository', 'MyAppointmentsService', 'PatientPortalStorageRepository', 'AppointmentRepository', 'toaster','aprgettext', 'TransitionManager',
        function ($scope, $q, $log, ListService, MyAppointmentsRepository, MyAppointmentsService, PatientPortalStorageRepository, AppointmentRepository, toaster, gettext, TransitionManager) {
            'use strict';

            $scope.loading = true;

            $scope.patientCalendars = [];
            $scope.patientAppointmentTypes = [];
            $scope.openAppointmentSlots = [];
            $scope.selectedTimeSlotInvalid = false;

            $scope.datepickerOptions = {
                minDate: moment().toDate(),
                maxDate: moment().add(1, 'years').toDate(),
                showWeeks: false,
                minMode: 'day',
                maxMode: 'day'
            };

            $scope.appointment = {
                Calendar: { Id: '', Description: ''},
                AppointmentType: { Id: ''},
                RequestDateTime: null,
                Reason: ''
            };
            $scope.datePicker = { selectedDate: ''};

            $scope.appointmentLocation = {
                Id: '',
                Name: '',
                GoogleMapsUrl: '',
                Address1: '',
                Address2: '',
                City: '',
                State: '',
                Zip: '',
                PhoneNumber: ''
            };
            $scope.appointmentLocationDefined = false;
            var activePatient = PatientPortalStorageRepository.getActivePatient();
            var myTimeZone;

            function loadPage() {
                $scope.loading = true;
                $scope.removeHttpError();
                activePatient = PatientPortalStorageRepository.getActivePatient();
                var calendarList = ListService.getList('calendar', $scope, 'calendars');
                var serviceSiteList = ListService.getList('servicesite', $scope, 'serviceSites');
                var appointmentTypeList = ListService.getList('appointmenttype', $scope, 'appointmentType');
                var loadTimeZonePromise = loadTimeZone();

                $q.all([calendarList, serviceSiteList, appointmentTypeList, loadTimeZonePromise]).then(function () {
                    if ($scope.calendars) {
                        $scope.patientCalendars = _($scope.calendars)
                            .filter({'AllowPatientRequest': true})
                            .value();
                    }

                    if ($scope.appointmentType) {
                        $scope.patientAppointmentTypes = _($scope.appointmentType)
                            .filter({'AllowPatientRequest': true})
                            .value();
                    }

                    if (MyAppointmentsService.isNewRequestedAppointment()) {
                        if ($scope.patientCalendars) {
                            $scope.appointment.Calendar.Id = $scope.patientCalendars[0].Id;
                        }
                        if ($scope.patientAppointmentTypes) {
                            $scope.appointment.AppointmentType.Id = $scope.patientAppointmentTypes[0].Id;
                            $scope.selectedAppointmentTypeDescription = $scope.patientAppointmentTypes[0].Description;
                        }
                        $scope.datePicker.selectedDate = new Date();
                    }
                    else {
                        var requestedAppointment = MyAppointmentsService.getRequestedAppointment();
                        var appointmentType = _.find($scope.appointmentType, {Id: requestedAppointment.AppointmentType.Id});

                        $scope.appointment.Calendar.Id = requestedAppointment.Calendar.Id;
                        $scope.appointment.AppointmentType.Id = requestedAppointment.AppointmentType.Id;
                        $scope.selectedAppointmentTypeDescription = appointmentType.Description;
                        $scope.appointment.Reason = requestedAppointment.Reason;
                        $scope.appointment.RequestDateTime = requestedAppointment.RequestDateTime;  // bound to appointment slot in view
                        $scope.datePicker.selectedDate = requestedAppointment.RequestDateTime;      // bound to selected datepicker date in view

                        MyAppointmentsService.clearRequestedAppointment();
                    }

                    assignTimeZone();
                    selectAppointmentLocation();
                    populateOpenAppointmentSlots($scope.datePicker.selectedDate, $scope.appointment.RequestDateTime);

                    MyAppointmentsRepository.getAppointmentRequestMetadata($scope);
                }).catch(function (response) {
                    $scope.addHttpError(response);
                }).finally(function () {
                    $scope.loading = false;
                });
            }
            loadPage();

            function loadTimeZone() {
                return MyAppointmentsRepository
                    .getTimeZone()
                    .then(function (data) {
                        myTimeZone = data;
                    });
            }

            function assignTimeZone() {
                _.forEach($scope.patientCalendars, function(calendar) {
                    if(calendar.TimeZone === null) {
                        calendar.TimeZone = myTimeZone.StandardName;
                    }
                });
            }

            function clearAppointmentLocation() {
                $scope.appointmentLocationDefined = false;
                $scope.appointmentLocation.Id = '';
                $scope.appointmentLocation.Name = '';
                $scope.appointmentLocation.GoogleMapsUrl = '';
                $scope.appointmentLocation.Address1 = '';
                $scope.appointmentLocation.Address2 = '';
                $scope.appointmentLocation.City = '';
                $scope.appointmentLocation.State = '';
                $scope.appointmentLocation.Zip = '';
                $scope.appointmentLocation.PhoneNumber = '';
            }
            function selectAppointmentLocation() {
                clearAppointmentLocation();
                var selectedCalendar = _.find($scope.patientCalendars, {Id: $scope.appointment.Calendar.Id});
                if (selectedCalendar && selectedCalendar.DefaultServiceSiteId) {
                    var serviceSite = _.find($scope.serviceSites, {Id: selectedCalendar.DefaultServiceSiteId});
                    if (serviceSite) {
                        $scope.appointmentLocation.Id = (serviceSite.Id) ? serviceSite.Id : '';
                        $scope.appointmentLocation.Name = (serviceSite.Description) ? serviceSite.Description : '';
                        if(serviceSite.Address)
                        {
                            if(serviceSite.Address.Address1) {
                                $scope.appointmentLocation.Address1 = serviceSite.Address.Address1;
                                $scope.appointmentLocationDefined = true;
                            }
                            $scope.appointmentLocation.Address2 = (serviceSite.Address.Address2) ? serviceSite.Address.Address2 : '';
                            $scope.appointmentLocation.City = (serviceSite.Address.City) ? serviceSite.Address.City : '';
                            $scope.appointmentLocation.State = (serviceSite.Address.State) ? serviceSite.Address.State : '';
                            $scope.appointmentLocation.Zip = (serviceSite.Address.Zip) ? serviceSite.Address.Zip : '';
                        }
                        if(serviceSite.PhoneNumber)
                        {
                            $scope.appointmentLocation.PhoneNumber = (serviceSite.PhoneNumber.PhoneNumber) ? serviceSite.PhoneNumber.PhoneNumber : '';
                        }

                    }
                }
            }

            function populateOpenAppointmentSlots(selectedDate, selectedTime) {
                $scope.loadingAppointmentSlots = true;
                $scope.removeHttpError();
                var startDate = moment(selectedDate).hour(0).minute(0).second(0).toDate();
                var endDate = moment(startDate).add(1, 'days').hour(0).minute(0).second(0).toDate();


                if ($scope.appointment.AppointmentType.Id) {
                    var selectedCalendar = _.find($scope.patientCalendars, {Id: $scope.appointment.Calendar.Id});
                    if (selectedCalendar) {
                        $scope.appointment.Calendar.Description = (selectedCalendar.Description) ? selectedCalendar.Description : '';
                        $scope.appointment.Calendar.TimeZone = (selectedCalendar.TimeZone) ? selectedCalendar.TimeZone : '';
                        var searchFilter = {
                            StartDate: startDate,
                            EndDate: endDate,
                            AppointmentTypeId: $scope.appointment.AppointmentType.Id
                        };

                        MyAppointmentsRepository
                            .getAppointmentsOpenTimeSlots(activePatient.id, selectedCalendar.Id, searchFilter)
                            .then(function (data) {
                                $scope.openAppointmentSlots = _(data)
                                    .forEach(function (item) {
                                        item.Selected = false;
                                        if (selectedTime) {
                                            if (moment(selectedTime).isSame(item.StartDate)) {
                                                item.Selected = true;
                                            }
                                        }
                                    });
                            })
                            .catch(function (response) {
                                $scope.addHttpError(response);
                            })
                            .finally(function () {
                                $scope.loadingAppointmentSlots = false;
                            });
                    }
                }
            }


            $scope.selectedCalendarChanged = function selectedCalendarChanged() {
                selectAppointmentLocation();
                populateOpenAppointmentSlots($scope.datePicker.selectedDate);
                $scope.appointment.RequestDateTime = null;
                $scope.selectedTimeSlotInvalid = false;
            };


            $scope.selectedAppointmentTypeChanged = function selectedAppointmentTypeChanged() {
                populateOpenAppointmentSlots($scope.datePicker.selectedDate);
                $scope.appointment.RequestDateTime = null;
                $scope.selectedTimeSlotInvalid = false;
                var selectedApptType = _.find(($scope.patientAppointmentTypes),
                    {'Id': $scope.appointment.AppointmentType.Id});
                $scope.selectedAppointmentTypeDescription = (selectedApptType) ? selectedApptType.Description : '';
            };


            $scope.datePickerChanged = function datePickerChanged() {
                populateOpenAppointmentSlots($scope.datePicker.selectedDate);
                $scope.appointment.RequestDateTime = null;
                $scope.selectedTimeSlotInvalid = false;
            };

            $scope.SelectedTimeSlotClick = function SelectedTimeSlotClick() {
                $scope.selectedTimeSlotInvalid = !$scope.appointment.RequestDateTime;
            };

            function validateRequestDate(form) {
                if (!$scope.datePicker.selectedDate) {
                    form.RequestDate.$invalid = true;
                    form.RequestDate.$dirty = true;
                }
                else {
                    form.RequestDate.$invalid = false;
                }
            }

            function validateSelectedTimeSlot() {
                $scope.selectedTimeSlotInvalid = !$scope.appointment.RequestDateTime;

                //if (!$scope.appointment.RequestDateTime) {
                //    form.SelectedTimeSlot.$invalid = true;
                //    form.SelectedTimeSlot.$dirty = true;
                //}
                //else {
                //    form.SelectedTimeSlot.$invalid = false;
                //}
            }

            function validateAppointmentReason(form) {
                if (!$scope.appointment.Reason) {
                    form.AppointmentReason.$invalid = true;
                    form.AppointmentReason.$dirty = true;
                }
                else {
                    form.AppointmentReason.$invalid = false;
                }
            }

            function isFormValid(form) {
                if ($scope.selectedTimeSlotInvalid  || form.RequestDate.$invalid || form.AppointmentReason.$invalid) {
                    form.$valid = false;
                }
                else {
                    form.$valid = true;
                }
            }

            $scope.requestAppointment = function requestAppointment(form) {
                form.isSubmitted = true;

                validateRequestDate(form);
                validateSelectedTimeSlot();
                validateAppointmentReason(form);
                isFormValid(form);

                if (form.$valid) {
                    $scope.sending = true;

                    var apptRequest = {
                        AppointmentTypeId: $scope.appointment.AppointmentType.Id,
                        CalendarId: $scope.appointment.Calendar.Id,
                        Reason: $scope.appointment.Reason,
                        RequestDateTime: $scope.appointment.RequestDateTime
                    };

                    MyAppointmentsRepository
                        .requestAppointment(activePatient.id, apptRequest)
                        .then(function () {
                            MyAppointmentsService.clearRequestedAppointment();
                            var requestedAppointment = {
                                Message: {Id: ''},
                                Calendar: {
                                    Id: $scope.appointment.Calendar.Id,
                                    Description: $scope.appointment.Calendar.Description
                                },
                                AppointmentType: {Id: $scope.appointment.AppointmentType.Id},
                                RequestDateTime: $scope.appointment.RequestDateTime,
                                Reason: $scope.appointment.Reason
                            };
                            MyAppointmentsService.cacheRequestedAppointment(requestedAppointment);

                            TransitionManager.transition({appRoute: 'confirmRequestedAppointment'});
                            //toaster.pop('success', '', gettext('Appointment request sent successfully.'));
                        })
                        .catch(function () {
                            toaster.pop('error', '', gettext('An error has occurred and the appointment request was not sent.'));
                        })
                        .finally(function () {
                            $scope.sending = false;
                        });
                }
                else {
                    if ($scope.selectedTimeSlotInvalid) {
                        toaster.pop('warning', '', gettext('An appointment time must be selected in order to request an Appointment.'));
                    }
                    else if (form.RequestDate.$invalid) {
                        toaster.pop('warning', '', gettext('An appointment date must be selected in order to request an Appointment.'));
                    }
                    else if (form.AppointmentReason.$invalid) {
                        toaster.pop('warning', '', gettext('An appointment reason must be entered in order to request an Appointment.'));
                    }
                }
            };
        }]);